import React from 'react';
import Typography, {
  TypographyProps as MUITypographyProperties,
} from '@mui/material/Typography';

export type TypographyProperties =
  Component.Properties<MUITypographyProperties>;

const MaterialUITypography = ({
  align,
  children,
  tag,
  className,
  noWrap,
  variant,
  color,
}: TypographyProperties) => (
  <Typography
    align={align ?? 'inherit'}
    // @ts-expect-error component is mapped by variant
    component={tag}
    className={className}
    noWrap={noWrap ?? false}
    variant={variant}
    color={color ?? 'textPrimary'}
  >
    {children}
  </Typography>
);

export default MaterialUITypography;
